import { FC, useEffect, useRef } from 'react';
import { ModelClusterInfo, ShopStatus } from '../ts-config';
import { markerActiveColorOption, markerDefaultColorOption } from '@/common/enums/business/siteselectionmap';
import { isArray, isDef, isNotEmpty, isNotEmptyAny } from '@lhb/func';
import styles from './index.module.less';
import { Typography } from 'antd';
import ReactDOM from 'react-dom';
import cs from 'classnames';
import { showMarker } from '@/common/utils/map';
import IconFont from '@/common/components/IconFont';
import { useMethods } from '@lhb/hook';
import { chancePointPoiMapList } from '@/common/api/expandStore/chancepoint';
import TargetBrand from './TargetBrand';
import useUpdateEffect from '@/common/hook/updateEffect/useUpdateEffect';
import { StoreStatus } from '@/common/components/business/ExpandStore/ts-config';
// import { mapContainerAddress } from './CircleAddress';
export const mapContainerAddress = 'mapContainerAddress';
import { v4 } from 'uuid';
import { getModelClusterBase } from '@/common/api/expandStore/clusterAndDirect';

/**
 * 匹配商圈组件的地图逻辑处理 --详情和表单都共用
 */
const MapOfCIrcleAddress:FC<{
  amapIns,
  /** 商圈围栏数组 */
  clusterList,
  shopList,
  chancePoint,
  tableFilter,
  curDetail,
  setCurDetail,
  isMKD,
  /** 拓店任务商圈id，如果传入了拓店商圈，则绘制拓店商圈，且初始化时不绘制中心点及保护区 */
  expansionTaskClusterId,
  setCenterAddress,
  addCenterMarker,
  updateBusinessCircle,
}> = ({
  amapIns,
  clusterList,
  shopList,
  chancePoint,
  tableFilter,
  curDetail,
  setCurDetail,
  isMKD,
  expansionTaskClusterId,
  setCenterAddress,
  addCenterMarker,
  updateBusinessCircle,
}) => {

  const businessOverLayers: any = useRef<any>(null);
  const shopMarkersRef: any = useRef<any>(null);
  const chancePointMarkerRef: any = useRef([]); // 机会点Marker
  const hoverMarkerRef = useRef(null);// hoverMarker
  const massListRef = useRef<any>([]); // 海量点marker列表
  const activeMarker = useRef<any>(null); // 当前海量点marker的焦点
  const contentMarkerRef = useRef<any>(null);
  /** 拓店任务商圈覆盖物 */
  const expansiontaskClusterLayers = useRef<any>(null);

  useEffect(() => {
    if (tableFilter?.poiType) {
      methods.getTablePoiList();
    }
  }, [tableFilter]);

  useUpdateEffect(() => {
    if (!isNotEmptyAny(curDetail)) return;
    activeMarker.current && amapIns.remove(activeMarker.current);
    methods.createActiveMarker(curDetail);
  }, [curDetail]);

  useEffect(() => {
    if (amapIns && expansionTaskClusterId) {
      setTimeout(() => {
        methods.initExpansiontaskCluster();
      }, 400); // 延时400ms，防止受到外面初始化影响
    }
  }, [amapIns, expansionTaskClusterId]);

  const methods = useMethods({

    /** 获取拓店任务商圈数据 */
    getExpansiontaskClusterData() {
      return getModelClusterBase({ id: expansionTaskClusterId });
    },

    /** 初始化绘制拓店商圈，并视图居中
     * 参考 src/views/expandstore/pages/expansionFranchiseeCircleTask/pages/detail/components/CircleTaskDetailMap/index.tsx
     */
    async initExpansiontaskCluster() {
      if (!amapIns || !expansionTaskClusterId) {
        return;
      }
      methods.removeExpansiontaskCluster();

      const data = await methods.getExpansiontaskClusterData();
      if (!data) {
        return;
      }

      // 需要以外部的拓店任务商圈为中心，绘制中心点图标以及保护区域
      addCenterMarker(+data.centerLng, +data.centerLat);
      updateBusinessCircle(+data.centerLng, +data.centerLat);
      setCenterAddress({ cityId: '', lat: +data.centerLat, lng: +data.centerLng });

      const cluster: any = Object.assign(data, {
        id: `${v4()}${data.id}`,
        centerName: data.name,
        centerLat: data.centerLat,
        centerLng: data.centerLng,
        polygon: data.polygon,
        radius: data.radius,
        inCluster: true,
      });
      if (!cluster) return;
      let markers: any = []; // 所有商圈的围栏覆盖物：商圈和名称覆盖物
      const { radius, polygon } = cluster;
      if (radius) {
        markers = createBusinessCircle(cluster); // 绘制商圈围栏（圆）覆盖物
      } else if (isArray(polygon) && polygon.length) {
        markers = createBusinessPolygon(cluster);
      }
      const overlayGroup = new window.AMap.OverlayGroup(markers); // 围栏覆盖物群组
      amapIns.add(overlayGroup); // 添加到地图
      markers[0] && amapIns.setFitView(markers[0]); // 视口自适应

      // 商圈名称覆盖物
      renderBusinessName(cluster.id, cluster.centerName, cluster.inCluster);
      expansiontaskClusterLayers.current = overlayGroup;
    },

    /** 移除绘制拓店商圈，并视图居中 */
    removeExpansiontaskCluster() {
      if (amapIns && expansiontaskClusterLayers.current) {
        amapIns.remove(expansiontaskClusterLayers.current);
        expansiontaskClusterLayers.current = null;
      }
    },

    /** 获取周边门店列表对应的poi点位 */
    getTablePoiList() {
      chancePointPoiMapList({ ...tableFilter }).then((res: any) => {
        methods.clearMarker();
        methods.createMass(res);
      });
    },
    // 创建mass focus内容
    createContentMarker(value, activeMarker = null) {
      const offset = [-8, 0];
      const topBottom = 'top';
      const leftRight = 'center';

      contentMarkerRef.current && amapIns.remove(contentMarkerRef.current);
      contentMarkerRef.current = new window.AMap.Marker({
        position: [value.lng, value.lat],
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 60,
        extData: {
          isStore: true, // 是否是经营门店类型，聚合后需要隐藏
        }
      });
      amapIns.add(contentMarkerRef.current);
      methods.onClickMarker?.();
      showMarker(contentMarkerRef.current,
        <TargetBrand
          data={value}
          amapIns={amapIns}
          marker={contentMarkerRef.current}
          activeMarker={activeMarker}
          setCurDetail={setCurDetail}
        />);
    },
    // 创建mass
    createMass(data) {
      if (!isNotEmptyAny(data) || !data?.length) return;
      const value = data.map((item) => ({
        lnglat: [+item.lng, +item.lat],
        detail: item,
        ...item,
      }));

      var mass = new window.AMap.MassMarks(value, {
        opacity: 1,
        cursor: 'pointer',
        style: {
          url: `${data[0].icon}`,
          size: [24, 29],
          anchor: 'bottom-center'
        },
        zooms: [1, 20],
        zIndex: 140
      });
      mass.setMap(amapIns);

      mass.on('click', ({ data }) => {
        setCurDetail(data);
      });
      massListRef.current.push(mass);
    },
    // 创建active mass
    createActiveMarker(value) {
      const marker = new window.AMap.Marker({
        position: [value.lng, value.lat],
        content: `<img class="storeMarkerActive" src="${value.icon}"/>`,
        anchor: 'bottom-center',
        extData: value,
        zIndex: 160
      });
      activeMarker.current && amapIns.remove(activeMarker.current);
      activeMarker.current = marker;
      methods.createContentMarker(value, marker);
      amapIns.add(marker);
    },
    // 创建默认marker
    clearMarker() {
      contentMarkerRef.current && amapIns.remove(contentMarkerRef.current);
      massListRef.current?.map((mass) => {
        mass?.clear();
      });
      massListRef.current = [];
      activeMarker.current && amapIns?.remove(activeMarker.current);
    },
    // 点击mass 事件
    onClickMarker() {

    },
  });

  // 创建周边商圈
  const updateClusterList = (list: any) => {
    if (businessOverLayers.current) {
      amapIns.remove(businessOverLayers.current);
      businessOverLayers.current = null;
    }
    if (!isArray(list)) return;
    let markers: any = []; // 所有商圈的围栏覆盖物
    list.forEach((cluster: ModelClusterInfo) => {
      let tempMarkers: any = [];
      const { radius, polygon } = cluster;
      if (radius) {
        tempMarkers = createBusinessCircle(cluster); // 绘制商圈围栏（圆）覆盖物
      } else if (isArray(polygon) && polygon.length) {
        tempMarkers = createBusinessPolygon(cluster);
      }
      markers = markers.concat(tempMarkers);
    });
    const overlayGroup = new window.AMap.OverlayGroup(markers); // 围栏覆盖物群组
    amapIns.add(overlayGroup); // 添加到地图
    businessOverLayers.current = overlayGroup;

    list.forEach((cluster: ModelClusterInfo) => {
      if (cluster.inCluster) return;
      renderBusinessName(cluster.id, cluster.centerName, cluster.inCluster);
    });
  };
  // 创建圆形商圈
  const createBusinessCircle = (item: ModelClusterInfo) => {
    const { centerLng, centerLat } = item;
    if (!(isNotEmpty(centerLng) && isNotEmpty(centerLat))) return;
    const lnglat = [+centerLng, +centerLat];
    const fillColor = item.inCluster ? markerActiveColorOption : markerDefaultColorOption;
    const circle = new window.AMap.Circle({
      center: lnglat,
      radius: item?.radius, // 半径（米）
      strokeWeight: 1,
      strokeOpacity: 1,
      fillOpacity: 0.2,
      strokeStyle: 'dashed',
      strokeDasharray: [10, 10],
      bubble: true, // 为了支持在商圈围栏上测距
      extData: item,
      ...fillColor,
    });
    const marker = new window.AMap.Marker({
      position: lnglat,
      anchor: 'center',
      extData: item,
      content: `<div id="${item.id}"></div>`,
      bubble: true,
      zIndex: 20,
    });
    return [circle, marker];
  };
    // 创建多边形商圈
  const createBusinessPolygon = (item: ModelClusterInfo) => {
    const { centerLng, centerLat } = item;
    if (!(isNotEmpty(centerLng) && isNotEmpty(centerLat))) return;
    const lnglat = [+centerLng, +centerLat];
    // const path = item?.polygon?.map((item) => {
    //   return [+item.lng, +item.lat];
    // });
    const fillColor = item.inCluster ? markerActiveColorOption : markerDefaultColorOption;
    const polygon = new window.AMap.Polygon({
      path: item?.polygon,
      strokeOpacity: 1,
      fillOpacity: 0.2,
      strokeWeight: 1,
      strokeStyle: 'dashed',
      // zIndex: 60,
      anchor: 'bottom-center',
      bubble: true,
      extData: {
        id: item.id
      },
      ...fillColor
    });
    const marker = new window.AMap.Marker({
      position: lnglat,
      anchor: 'center',
      extData: item,
      content: `<div id="${item.id}"></div>`,
      bubble: true,
      zIndex: 20,
    });
    return [polygon, marker];
  };
  const renderBusinessName = (id, name, inCluster) => {
    const node = <div className={styles.businessNameWrapper}>
      <div
        className={cs(styles.markerContent, inCluster && styles.inCluster)}>
        <Typography.Text
          style={{ maxWidth: 165,
            color: '#fff',
            fontSize: 12,
          }}
          ellipsis={{ tooltip: name }}>
          {name}
        </Typography.Text>
      </div>
      <div className={cs(styles.point, inCluster && styles.inCluster)} />
    </div>;
    const el = document.getElementById(id);
    el && ReactDOM.render(node, el);
  };

  // 创建门店marker
  const createShopMarkers = (shopList: any) => {
    if (shopMarkersRef.current) {
      amapIns.remove(shopMarkersRef.current);
      shopMarkersRef.current = null;
    }
    if (!isNotEmptyAny(shopList)) return;

    const markers: any = [];
    shopList.forEach((shop) => {
      const marker = new window.AMap.Marker({
        anchor: 'bottom-center',
        position: new window.AMap.LngLat(+shop.lng, +shop.lat),
        // content: `<div id=${shop.id}></div>`,
        bubble: true,
      });
      // 已闭店门店不展示circle
      const showCircle = ![StoreStatus.Closed].includes(shop.status);
      const circle = showCircle ? new window.AMap.Circle({
        center: new window.AMap.LngLat(+shop.lng, +shop.lat),
        radius: shop?.protectRadius, // 半径（米）
        strokeWeight: 1,
        strokeOpacity: 1,
        fillOpacity: 0.2,
        strokeStyle: 'dashed',
        strokeDasharray: [10, 10],
        bubble: true, // 为了支持在商圈围栏上测距
        strokeColor: '#F53F3F', // 设置边框颜色
        fillColor: '#F53F3F', // 设置填充颜色
      }) : null;
      circle ? markers.push(marker, circle) : markers.push(marker);
      hoverStore(marker, shop);
      // marker.on('mousemove', () => mouseMoveMarker(shop));
      // marker.on('mouseout', () => mouseOutMarker());
      amapIns.add(marker);
      circle && amapIns.add(circle);

      showMarker(marker, <div className={styles.storeBox}>
        <img className={styles.outerImg} src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_outer.png`}/>
        <img className={styles.innerImg} src={shop?.logo ? shop?.logo : `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_store_default.png`}/>
      </div>);
    });
    // const overlayGroup = new window.AMap.OverlayGroup(markers); // 围栏覆盖物群组
    // amapIns.add(overlayGroup); // 添加到地图
    shopMarkersRef.current = markers;
  };

  // 绘制周边的机会点
  const createSurroundChancePoint = (chancePointList) => {
    if (chancePointMarkerRef.current?.length) {
      amapIns.remove(chancePointMarkerRef.current);
      chancePointMarkerRef.current = [];
    }
    chancePointList?.forEach((value) => {
      const showChancePoint = shopList.find((item) => item.lat === value.lat && item.lng === value.lng);
      if (isNotEmptyAny(showChancePoint)) return; // 如果同一经纬度已存在门店则不显示机会点
      createSingleChancePoint(value);
    });
  };
  const createSingleChancePoint = (value) => {
    // 剔除自身机会点
    // const { lng, lat } = centerMarkerRef?.current?.getPosition() || {};
    // if (value?.lng === lng && value?.lat === lat) return;

    const circle = new window.AMap.Circle({
      center: [value?.lng, value?.lat], // 圆心位置
      radius: value?.protectRadius, // 半径
      strokeColor: '#F53F3F', // 设置边框颜色
      fillColor: '#F53F3F', // 设置填充颜色
      fillOpacity: 0.1,
      strokeStyle: 'dashed',
      bubble: true,
    });

    const marker = new window.AMap.Marker({
      anchor: 'bottom-center',
      position: [value?.lng, value?.lat],
    });

    amapIns.add(circle);
    // 摩卡多&冲突时，只显示围栏不显示点位
    if (isMKD && value?.applyUserId) {
      chancePointMarkerRef.current.push(circle);
      return;
    };
    amapIns.add(marker);
    showMarker(marker, <IconFont iconHref='iconic_mendian-jihuidian' className='c-006 fs-24'/>);
    chancePointMarkerRef.current.push(marker, circle);

    if (value?.protectRadius) {
      hoverChancePointWithProtect(marker, value);
    } else {
      hoverChancePointWithoutProtect(marker, value);
    }
  };

  // 机会点没有区域保护
  const hoverChancePointWithoutProtect = (marker, value) => {
    // hover展示详情内容
    marker.on('mouseover', () => {
      const dom = document.querySelector(`.${mapContainerAddress}`);
      var pixel = amapIns.lngLatToContainer([value?.lng, value?.lat]);
      const { x, y } = pixel;
      const offset = [0, 0];
      let topBottom = 'top';
      let leftRight = 'center';
      if (y < 80) {
        topBottom = 'top';
      } else if ((dom?.clientHeight || 0) - y < 80) {
        topBottom = 'bottom';
        offset[1] = -24;
      }
      if (x < 150) {
        leftRight = 'left';
      } else if ((dom?.clientWidth || 0) - x < 150) {
        leftRight = 'right';
        offset[0] = -24;
      }
      const hoverMarker = new window.AMap.Marker({
        position: [value?.lng, value?.lat],
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 100
      });
      amapIns.add(hoverMarker);
      showMarker(hoverMarker, <div className={styles.chancePointContent}>
        <div className={styles.name}>{value?.regionName}</div>
        <div className={styles.status}>{value?.pointStatus}</div>
      </div>);
      hoverMarkerRef.current = hoverMarker;
    });
    marker.on('mouseout', () => {
      amapIns.remove(hoverMarkerRef.current);
    });
  };
    // 机会点有区域保护
  const hoverChancePointWithProtect = (marker, value) => {
    // hover展示详情内容
    marker.on('mouseover', () => {
      const dom = document.querySelector(`.${mapContainerAddress}`);
      var pixel = amapIns.lngLatToContainer([value?.lng, value?.lat]);
      const { x, y } = pixel;
      const offset = [0, 0];
      let topBottom = 'top';
      let leftRight = 'center';
      if (y < 190) {
        topBottom = 'top';
      } else if ((dom?.clientHeight || 0) - y < 190) {
        topBottom = 'bottom';
        offset[1] = -29;
      }
      if (x < 190) {
        leftRight = 'left';
      } else if ((dom?.clientWidth || 0) - x < 190) {
        leftRight = 'right';
        offset[0] = -24;
      }
      const hoverMarker = new window.AMap.Marker({
        position: [value?.lng, value?.lat],
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 100
      });
      amapIns.add(hoverMarker);


      showMarker(hoverMarker, <div className={styles.storeContent}>
        <div className={styles.name}>{value?.regionName}</div>
        <div className={styles.status}>
          <span className={styles.protect}>区域保护中</span>
        </div>
        {value?.pointStatus ? <div className={styles.card}>
          <span className={styles.label}>机会点状态</span>
          <span className={styles.content}>{value?.pointStatus}</span>
        </div> : <></>}
        {value?.applyUserName ? <div className={styles.card}>
          <span className={styles.label}>保护申请人</span>
          <span className={styles.content}>{value?.applyUserName}</span>
        </div> : <></>}

        {isDef(value?.daysRemaining) ? <div className={styles.card}>
          <span className={styles.label}>保护有效期</span>
          <span className={styles.content}>剩余{value?.daysRemaining}天</span>
        </div> : <></>}

        {value?.protectRadiusStr ? <div className={styles.card}>
          <span className={styles.label}>保护范围</span>
          <span className={styles.content}>{value?.protectRadiusStr}</span>
        </div> : <></>}
      </div>);
      hoverMarkerRef.current = hoverMarker;
    });
    marker.on('mouseout', () => {
      amapIns.remove(hoverMarkerRef.current);
    });
  };
    // 门店
  const hoverStore = (marker, value) => {
    // hover展示详情内容
    marker.on('mouseover', () => {
      const dom = document.querySelector(`.${mapContainerAddress}`);
      var pixel = amapIns.lngLatToContainer([value?.lng, value?.lat]);
      const { x, y } = pixel;
      const offset = [0, 0];
      let topBottom = 'top';
      let leftRight = 'center';
      if (y < 190) {
        topBottom = 'top';
      } else if ((dom?.clientHeight || 0) - y < 190) {
        topBottom = 'bottom';
        offset[1] = -29;
      }
      if (x < 190) {
        leftRight = 'left';
      } else if ((dom?.clientWidth || 0) - x < 190) {
        leftRight = 'right';
        offset[0] = -24;
      }
      const hoverMarker = new window.AMap.Marker({
        position: [value?.lng, value?.lat],
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 100
      });
      amapIns.add(hoverMarker);



      const background = value?.status === ShopStatus.Openning ? 'rgba(0,106,255,0.08)'
        : value?.status === ShopStatus.Delivered ? 'rgba(233, 248, 234, 1)'
          : 'rgba(146,165,202,0.07)';

      const color = value?.status === ShopStatus.Openning ? '#006AFF'
        : value?.status === ShopStatus.Delivered ? '#006F07'
          : '#222222';
      const isProtect = [ShopStatus.Signed, ShopStatus.Delivered, ShopStatus.Openning].includes(value?.status);
      const isClose = [StoreStatus.Closed].includes(value?.status);

      showMarker(hoverMarker, <div className={styles.storeContent}>
        <div className={styles.name}>{value?.name}</div>
        <div className={styles.status}>
          {isProtect
            ? <span className={styles.protect}>区域保护中</span>
            : <></>}
          <span
            className={styles.storeStatus}
            style={{
              background,
              color,
              marginLeft: isProtect ? '4px' : '0'

            }}
          >{value?.statusName}</span>
        </div>

        {isClose ? <div className={styles.card}>
          <span className={styles.label}>保护状态</span>
          <span className={styles.content}>未保护</span>
        </div> : <div className={styles.card}>
          <span className={styles.label}>保护有效期</span>
          <span className={cs(styles.content, styles.protecting)}>永久保护</span>
        </div>}

        {!isClose && value?.protectRadiusStr ? <div className={styles.card}>
          <span className={styles.label}>保护范围</span>
          <span className={styles.content}>{value?.protectRadiusStr}</span>
        </div> : <></>}

      </div>);
      hoverMarkerRef.current = hoverMarker;
    });
    marker.on('mouseout', () => {
      amapIns.remove(hoverMarkerRef.current);
    });
  };
  useEffect(() => {
    if (!amapIns) return;
    updateClusterList(clusterList);
  }, [clusterList]);

  useEffect(() => {
    createShopMarkers(shopList);
    if (!amapIns) return;
  }, [shopList]);

  useEffect(() => {
    if (!amapIns) return;
    createSurroundChancePoint(chancePoint);
  }, [chancePoint]);

  return <div></div>;
};
export default MapOfCIrcleAddress;
